export default __webpack_public_path__ + "static/media/gallery-image-8.e43a092a.jpg";